import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { SimulationParamsModel } from '../models/simulation-params.model';

@Injectable({
  providedIn: 'root'
})
export class SimulationService {


  private cdsBaseURL: string = "https://api.agroclimate.org/v2/simulation";
  public timeInterval: any;

  constructor(private http: HttpClient) {
    // TESTING
    //this.cdsBaseURL = "http://0.0.0.0:5000";
  }

  public requestPhenology(params: SimulationParamsModel): Observable<any> {
    return this.http.post(this.cdsBaseURL + '/phenology/publish', params );
  }

  public getPhenologyResult(id: String, crop: String, pYear: String): Observable<any> {
    return this.http.get(this.cdsBaseURL + '/phenology/consume?uuid[eq]=' + id + '&crop[eq]=' + crop + '&pyear[eq]=' + pYear);
  }
}
